import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { useAuth } from "@/AuthContext";
import LangToggle from "@/components/LangToggle";
import { ShieldCheck, ArrowLeft } from "lucide-react";

export default function Login() {
  const { t, user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate(user.is_admin ? "/admin" : "/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-bone flex flex-col">
      <header className="px-6 lg:px-8 h-16 flex items-center justify-between max-w-7xl mx-auto w-full">
        <Link to="/" className="flex items-center gap-2 text-ink-muted hover:text-ink" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> <span className="font-heading">PhysioSOAP</span>
        </Link>
        <LangToggle />
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
          className="w-full max-w-md"
        >
          <div className="bg-surface border border-hairline rounded-3xl p-10 shadow-soft">
            <div className="w-12 h-12 rounded-2xl bg-pine flex items-center justify-center text-bone font-heading text-xl">P</div>
            <h1 className="mt-6 font-heading text-3xl tracking-tight">{t.auth.title}</h1>
            <p className="mt-2 text-ink-muted">{t.auth.sub}</p>

            <button
              onClick={handleGoogle}
              className="mt-8 w-full inline-flex items-center justify-center gap-3 px-5 py-3.5 rounded-full bg-pine text-bone font-medium hover:bg-pine-hover transition"
              data-testid="google-signin-btn"
            >
              <GoogleG />
              {t.auth.google}
            </button>

            <div className="mt-8 flex items-start gap-3 text-xs text-ink-muted">
              <ShieldCheck className="w-4 h-4 text-pine flex-shrink-0 mt-0.5" />
              <span>{t.auth.hint}</span>
            </div>
          </div>
        </motion.div>
      </main>
    </div>
  );
}

function GoogleG() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#fff" d="M21.35 11.1H12v3.2h5.35c-.23 1.4-1.7 4.1-5.35 4.1-3.22 0-5.85-2.66-5.85-5.95s2.63-5.95 5.85-5.95c1.83 0 3.06.78 3.76 1.45l2.56-2.47C16.86 3.95 14.66 3 12 3 6.95 3 2.85 7.05 2.85 12.45c0 5.4 4.1 9.45 9.15 9.45 5.27 0 8.78-3.7 8.78-8.92 0-.6-.07-1.05-.43-1.88z"/></svg>
  );
}
